import secureLocalStorage from "react-secure-storage";

import { GET_APP_PREFERENCES } from "helpers/constants";
import { buildingApp } from "actions/loaders";

export const getAppPreferences = () => async (dispatch) => {
	dispatch(buildingApp(true));

	let appPreferences = await secureLocalStorage.getItem("appPreferences");

	if (!appPreferences?.algoChain)
		// appPreferences = { ...appPreferences, algoChain: "mainnet" };
		dispatch(setCurrentAlgoChain("mainnet"));
	else
		dispatch({
			type: GET_APP_PREFERENCES,
			payload: appPreferences,
		});

	dispatch(buildingApp(false));
};

export const setCurrentSelectedAccount = (accountID) => async (dispatch) => {
	try {
		const appPreferences = secureLocalStorage.getItem("appPreferences");
		if (accountID) secureLocalStorage.setItem("appPreferences", { ...appPreferences, "selected-account": accountID });

		dispatch({
			type: GET_APP_PREFERENCES,
			payload: { ...appPreferences, "selected-account": accountID },
		});
	} catch (error) {
		console.error(error);
	}
};

export const setCurrentAlgoChain = (algoChain) => async (dispatch) => {
	dispatch(buildingApp(true));

	try {
		const appPreferences = secureLocalStorage.getItem("appPreferences");

		if (algoChain) secureLocalStorage.setItem("appPreferences", { ...appPreferences, algoChain: algoChain });

		dispatch({
			type: GET_APP_PREFERENCES,
			payload: { ...appPreferences, algoChain: algoChain },
		});
	} catch (error) {
		console.error(error);
	}

	dispatch(buildingApp(false));
};
